import { makeAutoObservable } from "mobx";
import  { ILocaleItem, LocaleStatus } from "../../../services/api/locales-service";

export interface ILocaleChanges extends Partial<ILocaleItem> {
}

class LocaleStore {

    private _changes: ILocaleChanges = {} as ILocaleChanges;
    private _model: ILocaleItem = {} as ILocaleItem;
    private _onDefaultLocaleChange: (locale: string) => void;
    private _onDelete: (locale: string) => void;
    private _getLocaleName: (code: string) => string;

    constructor(
        model: ILocaleItem = {} as ILocaleItem,
        onDefaultLocaleChange: (locale: string) => void,
        onDelete: (locale: string) => void,
        getLocaleName: (code: string) => string,
    ) {
        this._setModel(model);
        this._onDefaultLocaleChange = onDefaultLocaleChange;
        this._onDelete = onDelete;
        this._getLocaleName = getLocaleName;
        makeAutoObservable(this);
    }


    public get localeCode():string {return this._model.locale; }
    public get localeName():string {return this._getLocaleName(this._model.locale)}
    public get enabled(): boolean {return this._changes.is_enabled ?? this._model.is_enabled}
    public get is_default(): boolean {return this._changes.is_default ?? this._model.is_default}
    public get localeStatus(): LocaleStatus {return this._model.locale_status}
    public get model(): ILocaleItem { return this._model; }

    private _setModel(model: ILocaleItem): void {
        this._model = model;
        this._changes = {} as ILocaleItem;
    }


    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public getUpdatedModel(): ILocaleItem {
        return {
            ...this._model, ...this._changes ,
        };
    }

    public handleDelete(): void {
        this._onDelete(this._model.locale);
    }

    /** sets default language */
    public setDefault(): void {
        this._changes.is_default = true;
        this._onDefaultLocaleChange(this._model.locale);
        this._clearChanges('is_default');
    }

    public unsetDefault(): void {
        this._changes.is_default = false;
        this._clearChanges('is_default');
    }

    public toggleEnabled = () => {
        if (this.enabled){
            this._changes.is_enabled = false;
        }
        else {
            this._changes.is_enabled = true;
        }
        this._clearChanges('is_enabled');
    }

    public isNewLocale():boolean { 
        return !!sessionStorage.getItem(this._model.locale) 
    };


    private _clearChanges(property: keyof ILocaleItem) {
        if (this._model[property] === this._changes[property]) {
            delete this._changes[property];
        }
    }
}

export default LocaleStore;